import "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
// src/components/If.tsx
function If(props) {
	if (Object.hasOwnProperty.call(props, "truthy") && props.truthy) return /* @__PURE__ */ jsx(Fragment$1, { children: props.children });
	if (Object.hasOwnProperty.call(props, "falsy") && !props.falsy) return props.children;
	return props.elseChildren || null;
}
export { If };

//# sourceMappingURL=If.js.map